module.exports = __webpack_public_path__ + "img/bonus_light_en.5300275a.svg";